<template>

  <div>
    <template
        v-for="(screen, screen_index) in form.screens"
        :key="screen_index"
    >
      <template v-if="screensVisibility[screen.id]">
          <div class="text-subtitle1" v-if="!screen.split_screen_by_fields">
             <span class="q-pr-md">{{screen.name}}</span>
            <q-btn @click="this.gotoScreen({'screen' : screen_index})" flat round color="primary" icon="s_edit" size="xs" />
          </div>
          <template
              v-for="(field, field_index) in screen.fields"
              :key="field_index"
          >
<!--            <div class="text-body2" v-if="getRealValue(field, fieldValues)">-->
<!--              <span >-->
<!--                  {{field.label}}: {{getRealValue(field, fieldValues)}}-->
<!--              </span>-->
<!--            </div>-->
          </template>
<!--        <div class="q-pa-md"></div>-->
      </template>
    </template>
  </div>

</template>

<script>
import {mapFields} from "vuex-map-fields";
import {getRealValue} from "@/helpers/form";
import {mapActions} from "vuex";


export default {
  props: {
    field:{}
  },
  data() {
    return {

    };
  },
  methods: {
    ...mapActions({
      setScreen: 'values/list/setScreen',
      setReviewVisible: 'values/list/setReviewVisible',
      setReviewScreenIndex: 'values/list/setReviewScreenIndex'
    }),
    getRealValue: getRealValue,
    gotoScreen(screen) {
      this.setReviewVisible();
      this.setReviewScreenIndex({index: this.activeScreen});
      this.setScreen(screen);
    },
  },
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings'
    }),
    ...mapFields('settings/list', {
      error: 'error',
      form: 'form',
      isLoading: 'isLoading'
    }),
    ...mapFields('values/list', {
      fieldValues: 'fieldValues',
      fieldsVisibility: 'fieldsVisibility',
      screensVisibility: 'screensVisibility',
      review_visible: "review_visible",
      activeScreen: 'activeScreen'
    }),
  },
  mounted() {

  }
}
</script>
